import { Component } from '@angular/core';

// Children of AppModule instead of AppMainModule
@Component({
  selector: 'my-page-layout-fullscreen',
  styles: [],
  templateUrl: './fullscreen.component.html'
})

export class PageLayoutFullscreenComponent {}
